
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Path 749","xmlns":"http://www.w3.org/2000/svg","width":"27.58","height":"27.59"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 751","d":"M27.58 13.8a1.486 1.486 0 01-.439 1.055 1.454 1.454 0 01-1.055.449H15.294v10.792a1.516 1.516 0 01-1.5 1.494 1.486 1.486 0 01-1.055-.439 1.454 1.454 0 01-.449-1.055V15.305H1.494a1.507 1.507 0 01-1.066-2.559 1.567 1.567 0 011.066-.449h10.792V1.515a1.467 1.467 0 01.449-1.076A1.486 1.486 0 0113.79 0a1.52 1.52 0 011.5 1.515v10.781h10.792A1.523 1.523 0 0127.58 13.8z","fill":"#28345c"}})])
          )
        }
      }
    